import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const OnboardingRoute = ({ children }) => {
  const { isAuthenticated, accessToken, user } = useSelector(state => state.auth);

  // Must be authenticated
  if (!isAuthenticated || !accessToken) {
    return <Navigate to="/signin" replace />;
  }

  // If already completed onboarding, redirect to dashboard
  if (user && user.onboardingCompleted) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default OnboardingRoute;
